import { Button, Tour } from 'antd';
import { homeTourSteps } from './steps';
import styles from './styles.module.scss';
import { useLocalStorageState } from '../../../lib/hooks';
import { useState } from 'react';
const HomePageTour = () => {
  const [open, setOpen] = useState(false);
  const [completed, setCompleted] = useLocalStorageState('home-page-tour-last-completed', false);
  return <>
      <Button id="home-tour-button" onClick={() => setOpen(true)} type="primary" shape="round" size="large" className={`${styles.always} ${open || completed ? `` : styles.animated}`} children="QUICK TOUR" data-sentry-element="Button" data-sentry-source-file="index.jsx" />
      <Tour open={open} onClose={currentStep => {
      setCompleted(completed || currentStep + 1 === homeTourSteps.length);
      setOpen(false);
    }} steps={homeTourSteps} disabledInteraction={true} data-sentry-element="Tour" data-sentry-source-file="index.jsx" />
    </>;
};
export default HomePageTour;